import React, { useEffect, useMemo, useRef, useState } from "react";

import "./App.css";
import { Canvas, useFrame, useThree } from "@react-three/fiber";
import PointGeometry from "./component/Geometry/pointPosition.js";
import {
  Grid,
  Line,
  Text,
  OrbitControls,
  OrthographicCamera,
  Html,
} from "@react-three/drei";
import BoxGeometry from "./component/Geometry/BoxGeometry.js";
import WallGeometry from "./component/Geometry/WallGeometry.js";
import BackgroundImage from "./component/CanvasOverLays/background.js";
import { useDrawing } from "./hooks/useDrawing.js";
import { useActions } from "./hooks/useActions.js";
import CreateFiller from "./component/Geometry/filler.js";
import RomeDataManager from "./app/RomeDataManager.js";
import { cookies } from "./App";
import { setLinePlacementMode ,setSelectedButton,setSnapPoint} from "./features/drawing/drwingSlice.js";
import { DraggableDoor } from "./component/Geometry/DragDrop.js";
import ScaleContextMenu from "./component/Overlays/ScaleContextMenu.js";
import DrawtoolHeader from "./component/Overlays/DrawtoolHeader.js";
import { useDispatch, useSelector } from "react-redux";
import {
  backupLinesAndPoints,
  drawToolData,
  restoreLinesAndPoints,
  setAutoDrawData,
  setHelpVideo,
  setHelpVideoNumberr,
  setImageOpacity,
  setStoreLines,
  updateLineTypeId,
  setNovaPoints,
} from "./Actions/ApplicationStateAction.js";
import ContextualMenu from "./component/CanvasOverLays/ContextualMenu.js";
import ButtonComponent from "./component/Overlays/ButtonComponent.js";
import PropertiesPopup from "./component/Overlays/PropertiesPopup.js";
import RoomNamePopup from "./component/Overlays/RoomNamePopup.js";
import RoomFiller from "./component/Geometry/roomFiller.js";
import ScalePopup from "./component/Overlays/ScalePopup.js";
import { Scale } from "./component/Geometry/Scale.js";
import blade from "./assets/blade.png";
import {
  setContextualMenuStatus,
  setEnablePolygonSelection,
  setNewLine,
  setShiftPressed,
  setShowPopup,
  setShowSnapLine,
  setStop,
  setTypeId,
} from "./Actions/DrawingActions.js";
import UpdateDistance from "./component/Helpers/updateDistance.js";
import { Vector3, Shape } from "three";
import CappedLine from "./component/Geometry/CappedLine.js";
import { setSnapActive } from "./features/drawing/drwingSlice.js";
import CameraController from "./component/Helpers/CameraController.js";
import { useJoystick, JoystickPanDriver, JoystickOverlay } from "./component/Helpers/JoystickPan.js";
import { INITIAL_BREADTH, INITIAL_HEIGHT } from "./constant/constant.js";
import convert from "convert-units";
import BottomComponent from "./component/CanvasOverLays/BottomComponent.js";
import useModes from "./hooks/useModes.js";
import newCursor from "./assets/linedraw.png";
import usePoints from "./hooks/usePoints.js";
import TemporaryFiller from "./component/Geometry/temporaryFiller.js";
import cursor from "./assets/Default.png"
import SetScalePopup from "./component/Popups/SetScalePopup.js";
import HelpVideoPopup from "./component/Popups/HelpVideoPopup.js";
import useMouse from "./hooks/useMouse.js";
import FirstTimePopupCanvas from "./component/Popups/FirstTimePopupCanvas.js";
import FirstTimePopupUI from "./component/Popups/FirstTimePopupUI.js";
import UndoRedoButton from "./component/Overlays/UndoRedoButton.js";
import Logo from "./component/CanvasOverLays/Logo.js";
import EscapeHelper from "./component/CanvasOverLays/EscapeHelper.js";
import HelpPopup from "./component/Popups/HelpPopup.js";
import RoomSeperatorPopup from "./component/Popups/RoomSeperatorPopup.js";
import UpgradeComponent from "./component/Overlays/UpgradeComponent.js";
import UpgradePopup from "./component/Popups/UpgradePopup.js";
import { Helmet } from "react-helmet";
import PaymentConfirmationPopup from "./component/Popups/PaymentConfirmationPopup.js";
import ReactPlayer from "react-player";
import useResources from "./hooks/useResources.js";
import videoCover from "./assets/videoCover.png"
import ScaleInstructions from "./component/Overlays/ScaleInstructions.js";
import ScaleInstructions2 from "./component/Overlays/ScaleInstructions2.js";
import TutorialPopup from "./component/Popups/TutorialPopup.js";
import TutorialPopupUI from "./component/Popups/TutorialPopupUI.js";
import { setShowTutorialPopup } from "./Actions/PopupAction.js";
import zIndex from "@mui/material/styles/zIndex.js";
import * as THREE from "three";
import { findTopLeftPoint, removePointById } from "./utils/closestPoints.js";
import { findNextGuidedPoints } from "./utils/novaConnections.js";


const BlinkingSphere = ({ position, isHover, setIsHover, onHover, onHoverOut, isTutorialMode = false }) => {
  const pulseRef = useRef();

  // Cache geometry to avoid re-creation
  const geometry = useMemo(() => new THREE.SphereGeometry(10, 16, 16), []);

  // Static sphere material
  const staticMat = useMemo(
    () => new THREE.MeshBasicMaterial({
      transparent: true,
      opacity: 0.9
    }),
    []
  );

  // Pulsating sphere material with proper rendering properties
  const pulseMat = useMemo(
    () => new THREE.MeshBasicMaterial({
      transparent: true,
      opacity: 0.7,
      depthWrite: false,
      depthTest: false,
      blending: THREE.AdditiveBlending
    }),
    []
  );

  // Update both sphere colors based on hover state
  // Both tutorial and autoDraw mode: (normal: #4B73EC, hover: #2E2E2E)
  staticMat.color.set(isHover ? "#2E2E2E" : "#4B73EC");
  pulseMat.color.set(isHover ? "#2E2E2E" : "#4B73EC");

  useFrame((state) => {
    const mesh = pulseRef.current;
    if (!mesh) return;

    const time = state.clock.elapsedTime;
    const cycle = (time * 2) % 2; // 2-second cycle

    if (cycle < 1.5) {
      // Pulse animation: scale up and fade out
      const progress = cycle / 1.5;
      const scale = 1 + progress * 2; // Scale from 1 to 3
      const opacity = 0.7 * (1 - progress); // Fade from 0.7 to 0

      mesh.visible = true;
      mesh.scale.setScalar(scale);
      mesh.material.opacity = opacity;
    } else {
      // Hide during rest period
      mesh.visible = false;
      mesh.scale.setScalar(1);
      mesh.material.opacity = 0.7;
    }
  });

  const handlePointerOver = () => {
    setIsHover(true);
    if (onHover) onHover();
  };

  const handlePointerOut = () => {
    setIsHover(false);
    if (onHoverOut) onHoverOut();
  };

  return (
    <group>
      {/* Static sphere */}
      <mesh
        position={position}
        geometry={geometry}
        material={staticMat}
        onPointerOver={handlePointerOver}
        onPointerOut={handlePointerOut}
      />

      {/* Pulsating sphere */}
      <mesh
        ref={pulseRef}
        position={position}
        geometry={geometry}
        material={pulseMat}
        renderOrder={999}
        frustumCulled={false}
      />
    </group>
  );
};

export const CanvasComponent = () => {
  const dispatch = useDispatch();
  const {
    handleClick,
    handleLineClick,
    deleteSelectedLines,
    deleteSelectedRoom,
  } = useDrawing();
  const { handleMouseMove, handleMouseDown, handleMouseUp, 
    isSelecting,
    startPoint,
    endPoint,
    nearPoint,
    nearVal,
    draggingLineIndex,
    draggingLine,
    currentLinePostion,
    setCurrentLinePostion,
    currentMousePosition,
    currentStrightMousePosition,
    distance,
    curvePoints,
    curveAngle,
    curveAnglePosition,
    lineAngle
   } = useMouse();
  const { undo, redo } = useActions();
  const { toggleSelectionMode, perpendicularHandler } = useModes();
  const {screenToNDC, decimalToFeetInches} = usePoints();
  const { getRomeCdnUrl } = useResources(); 

  const {
    leftPos,
    rightPos,
    merge,
    lineBreak,
    perpendicularLine,
    linePlacementMode,
    measured,
    idSelection,
    roomSelectors,
    snapActive,
    userLength,
    userWidth,
    snapPoint
  } = useSelector((state) => state.drawing);
  const {
    storeBoxes,
    selectionMode,
    selectedLines,
    storeLines,
    factor,
    points,
    activeRoomIndex,
    designStep,
    expandRoomPopup,
    activeRoomButton,
    showSetScalePopup,
    img,
    escapeMessageShow,
    helpVideoNumber,
    showInstructionPopup,
    tutorialActive,
    backupLines,
    highlightPoint,
    ScaleSetState,
    autoDraw,
    novaPoints,
    novaPointConnections,
    user_role,
  } = useSelector((state) => state.ApplicationState);
  const { typeId, stop, showSnapLine, snappingPoint, temporaryPolygon, enablePolygonSelection,} = useSelector(
    (state) => state.Drawing
  );

  const {enableFirstTimePopup, showFirstTimePopup, firstTimePopupType, showTutorialPopup, tutorialPopupType} = useSelector((state) => state.PopupState);

  const getUrlParameter = (name) => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  };

  const controlsRef = useRef(null);

  const [zoom, setZoomState] = useState(1);
  const [isNeeded, setIsNeeded] = useState(false);
  const [isHover, setIsHover] = useState(false);
  const [gridFactor, setGridFactor] = useState(10);
  const { joystick, setActive } = useJoystick(0.12, 64);

  // State for managing blinking spheres
  const [blinkingPoints, setBlinkingPoints] = useState([]);
  const [hoveredPoint, setHoveredPoint] = useState(null);
  const [showClickHereHint, setShowClickHereHint] = useState(false);




  const setZoom = (zoom, val = true) => {
    setZoomState(zoom);
    setIsNeeded(val);
  };

  const handleKeyDown = (event) => {
    if(tutorialActive){
      return;
    }
    if (event.key === "s" || event.key === "S") {
      dispatch(setStop(!stop));
      window.GAEvent("DrawTool", "Shortcut", "SetStop");
    }
    if (
      (event.ctrlKey || event.metaKey) &&
      (event.key === "x" || event.key === "X")
    ) {
      perpendicularHandler();
      window.GAEvent("DrawTool", "Shortcut", "PerpendicularChange");
    }
    if (
      (event.ctrlKey || event.metaKey) &&
      (event.key === "z" || event.key === "Z")
    ) {
      undo();
      window.GAEvent("DrawTool", "Shortcut", "Undo");
    }
    if (
      (event.ctrlKey || event.metaKey) &&
      (event.key === "y" || event.key === "Y")
    ) {
      redo();
      window.GAEvent("DrawTool", "Shortcut", "Redo");
    }
    if (
      (event.ctrlKey || event.metaKey) &&
      (event.key === "c" || event.key === "C")
    ) {
      dispatch(setSnapActive(!snapActive));
      window.GAEvent("DrawTool", "Shortcut", "SnapActive");
    }
   
    if (
      (event.ctrlKey || event.metaKey) &&
      (event.key === "Q" || event.key === "q")
    ) {
      if (snapPoint === "normal") {
        dispatch(setSnapPoint("upper"));
        window.GAEvent("DrawTool", "Shortcut", "SnapPointUpper");
      } else {
        dispatch(setSnapPoint("normal"));
        window.GAEvent("DrawTool", "Shortcut", "SnapPointNormal");
      }
    }
    if (
      (event.ctrlKey || event.metaKey) &&
      (event.key === "b" || event.key === "B")
    ) {
      if (linePlacementMode === "midpoint") {
        dispatch(setLinePlacementMode("below"));
        window.GAEvent("DrawTool", "Shortcut", "LinePlacementModeBelow");
      } else {
        dispatch(setLinePlacementMode("midpoint"));
        window.GAEvent("DrawTool", "Shortcut", "LinePlacementModeMidpoint");
      }
    }
    if (
      event.key === "escape" ||
      (event.key === "Escape" && !merge && !lineBreak)
    ) {
      if (designStep === 2 && !selectionMode) {
        dispatch(setShowPopup(false));
        dispatch(setTypeId(0))
        toggleSelectionMode();
      } else if(activeRoomButton === "add" && designStep === 3){
        dispatch(setEnablePolygonSelection(!enablePolygonSelection))
      } 
      else if (!selectionMode) {
        dispatch(setNewLine(true));
        dispatch(setStop(true));
        dispatch(setShowSnapLine(false));
        dispatch(setContextualMenuStatus(false));
      }
      window.GAEvent("DrawTool", "Shortcut", "Escape");
    }
    if (selectionMode && (event.key === "Delete" || event.keyCode === 46)) {
      if (designStep === 3 && activeRoomIndex !== -1) {
        deleteSelectedRoom();
        window.GAEvent("DrawTool", "Shortcut", "DeleteRoom");
      } else {
        deleteSelectedLines();
        window.GAEvent("DrawTool", "Shortcut", "DeleteLine");
      }
    }
    if (event.key === "Shift") {
      dispatch(setShiftPressed(true));
      window.GAEvent("DrawTool", "Shortcut", "ShiftPressed");
    }
    if(!selectionMode && designStep === 2){
      if(event.key === "W" || event.key === "w"){
        dispatch(updateLineTypeId(1))
        window.GAEvent("DrawTool", "Shortcut", "LineTypeWall")
      }
      if(event.key === "D" || event.key === "d"){
        dispatch(updateLineTypeId(2))
        window.GAEvent("DrawTool", "Shortcut", "LineTypeDoor")
      }
      if(event.key === "R" || event.key === "r"){
        dispatch(updateLineTypeId(4))
        window.GAEvent("DrawTool", "Shortcut", "LineTypeRailing")
      }
      if(event.key === "N" || event.key === "n"){
        dispatch(updateLineTypeId(3))
        window.GAEvent("DrawTool", "Shortcut", "LineTypeWindow")
      }
    }
  };

  const handleKeyUp = (event) => {
    if (event.key === "Shift") {
      dispatch(setShiftPressed(false));
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("keyup", handleKeyUp);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("keyup", handleKeyUp);
    };
  }, [
    storeLines,
    selectionMode,
    selectedLines,
    points,
    stop,
    leftPos,
    rightPos,
    storeBoxes,
    designStep,
    perpendicularLine,
    snapActive,
    linePlacementMode,
    roomSelectors,
    enablePolygonSelection,
    temporaryPolygon
  ]);

  useEffect(() => {
    const floorplanId = getUrlParameter("floorplanId");
    if (floorplanId) {
      window.GAEvent("DrawTool", "AppOpened", "FloorplanOpened", floorplanId);
    }else{
      window.GAEvent("DrawTool", "AppOpened", "NoFloorplanId", "");
    }
    RomeDataManager.instantiate();
    if (cookies.get("USER-SESSION", { path: "/" }) !== undefined) {
      const result = cookies.get("LOGIN-RESPONSE", { path: "/" });

      RomeDataManager.setUserEmail(result.email, result.persistence_token);
      window.curentUserSession = result;
      window.GAEvent("DrawTool", "UserLanded", "LoggedIn", result.user_id);
    }
 

    dispatch(drawToolData(floorplanId));
    window.cameraContext = {}
  }, []);

  const createQuadrilateral = (p1, p2, p3, p4) => {
    const shape = new Shape();
    shape.moveTo(p1.x, p1.y);
    shape.lineTo(p2.x, p2.y);
    shape.lineTo(p3.x, p3.y);
    shape.lineTo(p4.x, p4.y);
    shape.lineTo(p1.x, p1.y);
    return shape;
  };

  const [test, setTest] = useState(null);

  const handleLineMove = (point) => {
    const line = storeLines[draggingLine];
      const linePoints = line.points;
      const lineLength = linePoints[1].distanceTo(linePoints[0]);
      if(Math.abs(linePoints[0].x - linePoints[1].x) > Math.abs(linePoints[0].y - linePoints[1].y)){
        const newStart = new Vector3(point.x - lineLength/2, point.y, 0);
        const newEnd = new Vector3(point.x + lineLength/2, point.y, 0);
        setTest([newStart, newEnd]);
        setCurrentLinePostion([newStart, newEnd]);
      } else {
        const newStart = new Vector3(point.x , point.y - lineLength/2, 0);
        const newEnd = new Vector3(point.x, point.y + lineLength/2, 0);
        setTest([newStart, newEnd]);
        setCurrentLinePostion([newStart, newEnd]);
      }
  }

  useEffect(()=>{
    const canvasContainer = document.querySelector(".canvas-container");
    const handlePointerMove = (event)=>{
      if(draggingLine){
        const point = screenToNDC(event.clientX, event.clientY);
        dispatch(setContextualMenuStatus(false));
        handleLineMove(point);
      }
    }
    if(draggingLine){
      canvasContainer.addEventListener("pointermove", handlePointerMove);
    }
    canvasContainer.addEventListener('contextmenu', (event)=>{
      event.preventDefault();
      event.stopPropagation();
    })
    return () => {
      canvasContainer.removeEventListener("pointermove", handlePointerMove);
      canvasContainer.removeEventListener('contextmenu', (event)=>{
        event.preventDefault();
        event.stopPropagation();
      })
    };
  },[draggingLine])

  useEffect(()=>{
    if(typeId === 0 && !selectionMode){
      toggleSelectionMode();
    }
  },[typeId, selectionMode])

  useEffect(()=>{
    switch(measured){
      case "in":
        setGridFactor(12);
        break;
      case "cm":
        setGridFactor(10);
        break;
      case "m":
        setGridFactor(0.1);
        break;
      case "mm":
        setGridFactor(100);
        break;
      default:
        setGridFactor(1);
        break;
    }
  },[measured])

  useEffect(()=>{
    var type = "";
    if(designStep  === 1 && helpVideoNumber === 1){
      type = "setScale";
      dispatch(setHelpVideoNumberr(2));
    }else if(designStep === 2 && helpVideoNumber === 2){
      type = "addWall";
      dispatch(setHelpVideoNumberr(3));
    }else if(designStep === 3 && helpVideoNumber === 3){
      // type = "defineRoom";
      // dispatch(setHelpVideoNumberr(4));
    }
    if(showInstructionPopup){
      type = "instruction";
    }
    if(tutorialActive){
      type = "tutorial";
    }
    dispatch(setHelpVideo(true, type));
  },[designStep, tutorialActive])

  var feetLength = 0;
  if(measured === "ft"){
    feetLength = decimalToFeetInches(distance);
  }

  const videoData = {
    1: {
      videoUrl: "/videos/drawTool/NewSetScale.mov"
    },
    2: {
      videoUrl: "/videos/drawTool/addNewWall.mov"
    },
    3: {
      videoUrl: "/videos/drawTool/defineRoom.mov"
    }
  }

  const helpVideo = useMemo(()=>{
    console.log("videoData[ScaleSetState?1:designStep].videoUrl", videoData[ScaleSetState?1:designStep].videoUrl)
    return <ReactPlayer
    playsinline
    playing={true}
    muted
    controls
    loop
    pip
    className="help-popup-video fixed-width"
    url={getRomeCdnUrl() + videoData[ScaleSetState?1:designStep].videoUrl}
  />
  },[designStep, ScaleSetState])

  useEffect(()=>{
    if(tutorialActive){
      dispatch(setShowTutorialPopup({
        showTutorialPopup: true,
        tutorialPopupType: "canvas",
        tutorialPopupNumber: 1,
        tutorialPopupDismissable: false
      }))
      dispatch(setImageOpacity(0.6))
      if(!selectionMode){
        toggleSelectionMode();
      }
    }
  },[tutorialActive])

  // Initialize blinking points when nova points are available
  useEffect(() => {
    if (autoDraw && img && novaPoints && novaPoints.length > 0 && storeLines.length === 0) {
      // STEP 1: Show only the top-left point initially (before any clicks)
      const topLeft = findTopLeftPoint(novaPoints);
      if (topLeft) {
        setBlinkingPoints([topLeft]);
        setShowClickHereHint(true); // Show hint for first point
      }
    } else if (!autoDraw || !img || novaPoints.length === 0) {
      setBlinkingPoints([]);
      setShowClickHereHint(false);
    }
  }, [autoDraw, img, novaPoints.length, storeLines.length]);

  // Update blinking points when a line is added (after user clicks)
  useEffect(() => {
    if (autoDraw && img && novaPoints && novaPoints.length > 0 && storeLines.length > 0 && novaPointConnections) {
      // STEP 2: After first click, show connected guided points based on line topology
      setShowClickHereHint(false); // Hide hint after first click

      const lastLine = storeLines[storeLines.length - 1];
      const lastPoint = lastLine.points[1]; // End point of the last line

      // Find remaining nova points that haven't been used in any line
      const remainingPoints = novaPoints.filter(item =>
        !storeLines.some(line =>
          line.points.some(linePoint =>
            linePoint.x === item.x && linePoint.y === item.y && linePoint.z === item.z
          )
        )
      );

      // Remove used points from novaPoints state
      if (remainingPoints.length < novaPoints.length) {
        dispatch(setNovaPoints(remainingPoints));
      }

      if (remainingPoints.length > 0) {
        // Use line topology to find next guided points
        // Pass both remainingPoints and all novaPoints (before filtering) to find the last point
        const allPoints = novaPoints; // This includes all points before removal
        const guidedPoints = findNextGuidedPoints(lastPoint, novaPointConnections, remainingPoints, allPoints);
        setBlinkingPoints(guidedPoints);
      } else {
        setBlinkingPoints([]);
      }
    }
  }, [storeLines.length]);

  // Handle hover over blinking sphere
  const handleBlinkingSphereHover = (pointId) => {
    setHoveredPoint(pointId);
  };

  const handleBlinkingSphereHoverOut = () => {
    setHoveredPoint(null);
  };

  // Remove point by ID (called when user clicks on a point after forming a line)
  const removeNovaPointById = (pointId) => {
    const updatedNovaPoints = removePointById(novaPoints, pointId);
    dispatch(setNovaPoints(updatedNovaPoints));
  };

  return (
    <div className="container">
       <Helmet>
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=%REACT_APP_GA_ID%"
        ></script>
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            gtag = function () { dataLayer.push(arguments); }
            gtag('js', new Date());

            gtag('config', '%REACT_APP_GA_ID%', { 'optimize_id': '%REACT_APP_OPTIMIZE_ID%' });
          `}
        </script>
        <script
            src="https://checkout.razorpay.com/v1/checkout.js"
        ></script>
      </Helmet>
      <div
        className="canvas-container"
        onMouseMove={handleMouseMove}
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        style={
          designStep === 1 && !tutorialActive
            ? { cursor: "grab" }
            : lineBreak
            ? { cursor: `url(${blade}) 8 8, crosshair` }
            : selectionMode
            ? designStep === 3
              ? enablePolygonSelection
                ? { cursor: `url(${newCursor}) 16 16, crosshair` }
                : { cursor: `url(${cursor}) 4 4, default` }
              : { cursor: "grab" }
            : { cursor: `url(${newCursor}) 16 16, crosshair` }
        }
      >
        
        {/* 2D (Orthographic) Canvas */}
        <Canvas
          style={{
            height: window.innerHeight,
            width: "100%",
            background: "#EFEFEF",
          }}
          orthographic
          raycaster={{ params: { Line: { threshold: 10 } } }}
          camera={{ 
            position: [0, 0, 1000], 
            zoom: 1,
            far: 2000,
          }}
          onClick={handleClick}
          gl={{ powerPreference: 'high-performance' }}
        >

          <CameraController controlsRef={controlsRef} zoom={zoom} setZoom={setZoom} isNeeded={isNeeded} />
          <JoystickPanDriver
            joystick={joystick}
            controlsRef={controlsRef}
            enabled={true}
            basePanSpeed={60.0}
          />

          {/* {isSelecting && startPoint && endPoint && (
            <mesh>
              <shapeGeometry
                attach="geometry"
                args={[
                  createQuadrilateral(
                    startPoint,
                    new Vector3(endPoint.x, startPoint.y, 0),
                    endPoint,
                    new Vector3(startPoint.x, endPoint.y, 0)
                  ),
                ]}
              />
              <meshBasicMaterial
                color={"rgba(0, 0, 255, 0.2)"}
                transparent={true}
                opacity={0.2}
              />
            </mesh>
          )} */}
          {tutorialActive && highlightPoint && (
            <BlinkingSphere
              position={highlightPoint}
              isHover={isHover}
              setIsHover={setIsHover}
              isTutorialMode={true}
            />
          )}

          {/* Render blinking spheres for nova points */}
          {autoDraw && img && blinkingPoints.length > 0 && blinkingPoints.map((item, index) => (
            <React.Fragment key={`blinking-${item.id}`}>
              <BlinkingSphere
                position={[item.x, item.y, item.z]}
                isHover={hoveredPoint === item.id}
                setIsHover={setIsHover}
                onHover={() => handleBlinkingSphereHover(item.id)}
                onHoverOut={handleBlinkingSphereHoverOut}
                isTutorialMode={false}
              />
              {/* Show "Click here" hint only for the first top-left point */}
              {showClickHereHint && index === 0 && (
                <Html sprite={true} distanceFactor={1} position={[item.x - 80, item.y, item.z]} center>
                  <div
                    style={{
                      width: '82px',
                      height: '23px',
                      backgroundColor: 'white',
                      color: '#4B73EC',
                      padding: '2px 8px',
                      borderRadius: '16px',
                      border: '1px solid #4B73EC',
                      fontSize: '12px',
                      fontWeight: '600',
                      whiteSpace: 'nowrap',
                      opacity: 1,
                      pointerEvents: 'none',
                      userSelect: 'none',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px',
                    }}
                  >
                    Click here
                  </div>
                </Html>
              )}
            </React.Fragment>
          ))}

          {nearPoint && lineBreak && <UpdateDistance nearVal={nearVal} />}

          {designStep === 2 && showSetScalePopup && ScaleSetState && img && !tutorialActive && <Scale />}
          <BackgroundImage />
          {/* Render lines in 2D view */}
          {img && autoDraw && novaPoints?.map((item, index) => {
            return (<PointGeometry
              key={`point-${item.id}`}
              position={item.point || new Vector3(item.x, item.y, item.z)}
              designStep={designStep}
              isHighlighted={highlightPoint &&
                (highlightPoint instanceof Vector3
                  ? highlightPoint.equals(item.point || new Vector3(item.x, item.y, item.z))
                  : new Vector3(highlightPoint.x, highlightPoint.y, highlightPoint.z).equals(item.point || new Vector3(item.x, item.y, item.z))
                )
              }
              opacity={0.5}
            />);}
          )}
          {(designStep > 1 || tutorialActive /*&& !autoDraw*/) &&
            storeLines.map((line, index) => {
              const lineIndex = draggingLineIndex.find(
                (line) => line.index === index
              );
              return (
                <BoxGeometry
                  key={line.id}
                  start={
                    lineIndex !== undefined && lineIndex.type === "start"
                      ? currentMousePosition
                      : test && draggingLine === index
                      ? test[0]
                      : line.points[0]
                  }
                  end={
                    lineIndex !== undefined && lineIndex.type === "end"
                      ? currentMousePosition
                      : test && draggingLine === index
                      ? test[1]
                      : line.points[1]
                  }
                  dimension={{ width: line.width, height: line.height }}
                  typeId={line.typeId}
                  isSelected={selectedLines.includes(line.id)}
                  lineId={line.id}
                />
              );
            })}
          {designStep === 2 &&
            draggingLineIndex.length === 0 &&
            !currentLinePostion && 
              storeLines.map((line, index) => {
                return(
                  <CappedLine line={line} index={index} />
                )
              })
            }
          {designStep > 1 &&
            showSnapLine &&
            snappingPoint.length >= 0 &&
            !lineBreak && !autoDraw && (
              <Line
                points={[snappingPoint[1], snappingPoint[0]]}
                color="green"
                lineWidth={5}
              />
            )}

          {(designStep === 2 || tutorialActive) &&
            currentMousePosition &&
            points.length > 0 &&
            !stop && (
              <>
                <Line
                  points={[points[points.length - 1], currentMousePosition]}
                  color="black"
                  lineWidth={2}
                />
                <BoxGeometry
                  start={points[points.length - 1]}
                  end={currentMousePosition}
                  dimension={{
                    width: convert(INITIAL_BREADTH / factor[1])
                      .from(measured)
                      .to("mm"),
                    height: convert(INITIAL_HEIGHT / factor[2])
                      .from(measured)
                      .to("mm"),
                  }}
                  typeId={typeId}
                  isSelected={false}
                  showDimension={(tutorialActive && img)? false: true}
                  distance={
                    storeLines.length === 0 &&
                    userLength === 0 &&
                    userWidth === 0 &&
                    !img
                      ? true
                      : null
                  }
                />
                {currentStrightMousePosition && !perpendicularLine && curveAngle > 3 &&(
                  <>
                    <Line
                      points={[
                        points[points.length - 1],
                        currentStrightMousePosition,
                      ]}
                      color="blue"
                      lineWidth={5}
                    />
                    <Line points={curvePoints} color="black" lineWidth={1} transparent={true} opacity={0.5}/>
                    <Text
                      position={[
                        currentMousePosition.x - points[points.length - 1].x > 0 ? (points[points.length - 1].x +
                          currentStrightMousePosition.x) /
                          2 - 10: (points[points.length - 1].x +
                            currentStrightMousePosition.x) /
                            2 + 10,
                        currentMousePosition.y - points[points.length - 1].y > 0?
                        (points[points.length - 1].y +
                          currentStrightMousePosition.y) /
                          2 -
                          20: (points[points.length - 1].y +
                            currentStrightMousePosition.y) /
                            2 +
                            20,
                        0,
                      ]}
                      rotation={[0, 0 , lineAngle< 3? lineAngle: 0]}
                      color="black"
                      anchorX="center"
                      anchorY="middle"
                      fontSize={8}
                      fontWeight="bold"
                    >
                      {measured === "ft"
                        ? `${feetLength.feet}'${feetLength.inches} ${measured}`
                        : `${distance.toFixed(2)} ${measured}`}
                    </Text>
                    <Text
                      position={curveAnglePosition}
                      color="black"
                      anchorX="center"
                      anchorY="middle"
                      fontSize={8}
                      fontWeight="bold"
                    >
                      {curveAngle.toFixed(2)}°
                    </Text>
                  </>
                )}
              </>
            )}
          {/* {designStep === 2 &&
            storeBoxes.map((box, index) => (
              <CreateFiller
                key={index}
                p1={box.p1}
                p2={box.p2}
                p3={box.p3}
                p4={box.p4}
              />
            ))} */}

          {(designStep > 1 || tutorialActive) && <ContextualMenu />}
          {showFirstTimePopup && enableFirstTimePopup && firstTimePopupType==="canvas" && !tutorialActive && <FirstTimePopupCanvas />}
          {showFirstTimePopup && ScaleSetState && firstTimePopupType==="canvas" && !tutorialActive && <FirstTimePopupCanvas />}

          {showTutorialPopup && tutorialActive && tutorialPopupType==="canvas" && <TutorialPopup/>}

          {designStep === 3 &&
            roomSelectors.map((room, index) => (
              <RoomFiller
                key={room.roomId}
                polygon={room.polygon}
                roomName={room.roomName}
                roomType={room?.roomType}
                wallIds={room.wallIds}
                index={index}
              />
            ))}

          {designStep === 3 &&
            (activeRoomButton === "add" || activeRoomButton === "divide") &&
            temporaryPolygon.length > 0 && (
              <TemporaryFiller polygon={temporaryPolygon} />
            )}
          {designStep === 3 &&
            enablePolygonSelection &&
            currentMousePosition &&
            temporaryPolygon.length > 0 && (
              <>
                <Line
                  points={[
                    temporaryPolygon[temporaryPolygon.length - 1],
                    currentMousePosition,
                  ]}
                  color="blue"
                  lineWidth={2}
                />
              </>
            )}

          {/* 2D grid */}
          {/* <Grid
            rotation={[Math.PI / 2, 0, 0]}
            // cellSize={(1/factor[0]) * 10}
            cellThickness={0}
            cellColor="#FFFFFF"
            sectionSize={ designStep ===1 || showSetScalePopup ?  50 : (1/factor[0]) * gridFactor}
            //sectionThickness={1.5}
            sectionColor="#FFFFFF"
            fadeDistance={10000}
            infiniteGrid
            fadeStrength={0.5}
            fadeFrom={0.5}
            opacity={0.3}
            materialProps={{
              toneMapped: false,
              transparent: true,
              opacity: 0.3,
            }}
          /> */}
        </Canvas>

        {/* Overlay UI rendered outside the Canvas */}
        <JoystickOverlay joystickApi={joystick} setActive={setActive} className="joystick-overlay" />
        <DrawtoolHeader />

        {!tutorialActive && <UndoRedoButton/> }
        {/* <Logo/> */}
        {designStep === 3 && activeRoomButton!="" && <EscapeHelper/>}

        {designStep === 2 && !selectionMode && !tutorialActive && <EscapeHelper/>}
        <BottomComponent zoom={zoom} setZoom={setZoom} />
        <HelpPopup/>
        <RoomSeperatorPopup/>
        <UpgradePopup/>
        {!tutorialActive && img && user_role!="verifier" && <UpgradeComponent/> }
        <PaymentConfirmationPopup/>
      </div>
      {designStep > 1 || tutorialActive  ? (
        <div className="button-container">
          <div style={{ position: "relative" }}>
          {!tutorialActive &&
              <div
                className="perspective-canvas"
                style={{
                  position: "absolute",
                  right: "20px",
                  top: "20px",
                  backgroundColor: "#ffffff",
                  height: "166px",
                  width: "252px",
                  borderRadius: "16px",
                  boxShadow: "0px 4px 14px -3px #0C0C0D21",
                }}
              >
                {helpVideo}
               {/* <Canvas
                style={{
                  height: "100%",
                  width: "100%",
                  backgroundColor: "#EFEFEF",
                  borderRadius: "16px",
                }}
                orthographic
                camera={{ position: [0, 0, 800], fov: 75 }}
              >
                <OrthographicCamera
                  makeDefault
                  zoom={0.15}
                  position={[0, 0, 800]}
                />

                {/* Render lines in 3D view 
                {storeLines.map((line) => (
                  <WallGeometry
                    key={line.id}
                    start={line.points[0]}
                    end={line.points[1]}
                    dimension={{ width: line.width, height: line.height }}
                    widthchange={line.widthchange}
                    widthchangetype={line.widthchangetype}
                    type={line.type}
                    typeId={line.typeId}
                    isSelected={selectedLines.includes(line.id)}
                    isChoose={idSelection.includes(line.id)}
                    onClick={() => handleLineClick(line.id)}
                  />
                ))}

                {/* 3D grid 
                <Grid
                  rotation={[Math.PI / 2, 0, 0]}
                  cellSize={0}
                  cellThickness={0}
                  cellColor="black"
                  sectionSize={0}
                  sectionThickness={1.5}
                  sectionColor="lightgray"
                  fadeDistance={10000}
                  infiniteGrid
                />

                {/* Orbit controls for 3D view *
                <OrbitControls
                  enablePan={true} // Disable panning if needed
                  zoomToCursor={true}
                  maxAzimuthAngle={Math.PI / 3} // Limit horizontal rotation to 60 degrees (PI/3 radians)
                  minAzimuthAngle={-Math.PI / 3} // Limit horizontal rotation to -60 degrees (-PI/3 radians)
                  // maxPolarAngle={Math.PI / 3} // Limit vertical rotation to 60 degrees
                  // minPolarAngle={Math.PI / 2 - Math.PI / 3} // Limit vertical rotation to 30 degrees above the horizontal plane
                  defaultPolarAngle={Math.PI / 2 - Math.PI / 6} // Set default vertical angle to 30 degrees
                />
              </Canvas>  */}
            </div>
            }
            <PropertiesPopup />
            <RoomNamePopup />
            <ButtonComponent />
            {
              user_role!=="verifier" && 
              <HelpVideoPopup />
            }
            {!tutorialActive && ScaleSetState && designStep === 2 && <ScaleInstructions2/> }
            {showSetScalePopup && !tutorialActive && !img && <SetScalePopup />}
            {showFirstTimePopup && enableFirstTimePopup && firstTimePopupType==="ui" && !tutorialActive && <FirstTimePopupUI />}
            {showFirstTimePopup && ScaleSetState && firstTimePopupType==="ui" && !tutorialActive && <FirstTimePopupUI />}

            {showTutorialPopup && tutorialActive && tutorialPopupType==="ui" && <TutorialPopupUI />}
          </div>
        </div>
      ) : (
        <div className="button-container">
            {!tutorialActive &&
              <div
                className="perspective-canvas"
                style={{
                  position: "absolute",
                  right: "20px",
                  top: "20px",
                  backgroundColor: "#ffffff",
                  height: "166px",
                  width: "252px",
                  borderRadius: "16px",
                  boxShadow: "0px 4px 14px -3px #0C0C0D21",
                }}
              >
                {helpVideo}
              </div>
            }
          {/* <ScalePopup /> */}
          {/* {!tutorialActive && <ScaleInstructions/> } */}
          {    user_role!=="verifier" && 
            <HelpVideoPopup />
          }
          {showFirstTimePopup && enableFirstTimePopup && firstTimePopupType==="ui" && <FirstTimePopupUI />}
          {showFirstTimePopup && ScaleSetState && firstTimePopupType==="ui" && <FirstTimePopupUI />}

          {showTutorialPopup && tutorialActive && tutorialPopupType==="ui" && <TutorialPopupUI />}
        </div>
      )}
    </div>
  );
};

export default CanvasComponent;
